'use client'

import {
  Box,
  Center,
  Flex,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading, Text
} from '@chakra-ui/react'
import { ReactNode } from 'react'
import { IoIosStats } from 'react-icons/io'
import { BiSolidPencil } from 'react-icons/bi'
import { BiSolidUserVoice } from 'react-icons/bi'
import { CheckCircleIcon } from '@chakra-ui/icons'
import { COLORS } from "../../../colors"
import FormModal from "./formModal"



export default function WebAnalysis() {
  return (
    <Flex flexDirection={"column"} gap={2} align={"center"} justify={"center"} px={6} height={{ base: 'fit-content', lg: 400 }} py={{ base: 10, lg: 0 }} bgColor={COLORS.brand5}>
      <Heading textAlign={"center"} as="h2" size="xl" mt={6} mb={2} fontFamily={"Montserrat"}>
        ¿Quiénes somos?
      </Heading>
      <Text mt={3} textAlign={"center"} fontFamily={"Montserrat"} maxW={{ base: "100%", md: "70%" }}>
      Somerset Language Centre fue fundada en el año 2013, con el propósito de llevar el inglés a todas aquellas personas que lo necesitasen. Ofrecemos clases para todos los niveles tanto a niños, adolescentes y adultos. 
      </Text>
      <Text mt={3} textAlign={"center"} fontFamily={"Montserrat"} maxW={{ base: "100%", md: "70%" }}>
      Todos nuestros profesores son nativos o bilingües, cualificados y experimentados. A lo largo de los años hemos obtenido una muy buena reputación produciendo excelentes resultados. La calidad de la enseñanza, la experiencia y los grupos reducidos, entre 8 y 10 alumnos, garantizan nuestro éxito. 
      </Text>
      <Text mt={3} textAlign={"center"} fontFamily={"Montserrat"} maxW={{ base: "100%", md: "70%" }}>
      Nos encontramos en la Calle Ministro Luis Mayans, 31, Bajo. </Text>
    </Flex>
  )
}

function StatsCard(props) {
  const { title, stat, icon } = props
  return (
    <Stat
      px={{ base: 2, md: 4 }}
      width={{ base: "100%", md: "fit-content" }}
      py={'5'}
      shadow={'md'}
      border={'1px solid'}
      borderColor={useColorModeValue(COLORS.brand3, COLORS.brand2)}
      rounded={'lg'}>
      <Flex justifyContent={'space-between'} gap={3}>
        <Box pl={{ base: 2, md: 5 }}>
          <StatLabel fontWeight={'medium'} isTruncated color={COLORS.brand4}>
            {title}
          </StatLabel>
          <StatNumber fontSize={'2xl'} fontWeight={'medium'}>
            {stat}
          </StatNumber>
        </Box>
        <Box
          my={'auto'}
          color={COLORS.brand4}
          alignContent={'center'}>
          {icon}
        </Box>
      </Flex>
    </Stat>
  )
}

const BasicStatistics = () => {
  return (
    <Box maxW="7xl" mx={'auto'} pt={5} px={{ base: 2, sm: 12, md: 17 }} fontFamily={"Montserrat"}>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 5, lg: 8 }}>
        <StatsCard title={'SEO'} stat={'50%'} icon={<IoIosStats size={20} />} />
        <StatsCard title={'Diseño'} stat={'65%'} icon={<BiSolidPencil size={20} />} />
        <StatsCard title={'Alcance'} stat={'40%'} icon={<BiSolidUserVoice size={22} />} />
      </SimpleGrid>
      <Center py={6}><FormModal label="Pedir análisis" /></Center>
    </Box>
  )
}